// extracted by mini-css-extract-plugin
export default {"merckLogo":"Navbar_merckLogo__JvZh0"};